module.exports = __webpack_public_path__ + "static/media/4ODA10.a5fff9af.jpg";